import React from 'react'
import styled from 'styled-components'

import Icon from '../Icon'

const StyledHeader = styled.div`
  width: 100%;
  margin: 1em 0;
  display: flex;
  color: #414141;
`

const StyledMonth = styled.div`
  width: 60%;
  ${'' /* font-size: 24pt; */}
  font-size: 1.5em;
  display: flex;
  justify-content: center;
  align-items: center;
`

const StyledArrow = styled.button`
  background: none;
  border: none;
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: 0.25s;

  &:focus {
    outline: none;
  }

  &:active {
    transition: 0.25s;
    transform: scale(0.9);
  }
`

const CalendarHeader = ({ currentMonth, nextMonth, prevMonth }) => (
  <StyledHeader>
    <StyledArrow onClick={prevMonth}>
      <Icon size="sm" name="ChevronLeft" color="#414141" />
    </StyledArrow>
    <StyledMonth>{currentMonth.format('MMMM YYYY')}</StyledMonth>
    <StyledArrow onClick={nextMonth}>
      <Icon size="sm" name="ChevronRight" color="#414141" />
    </StyledArrow>
  </StyledHeader>
)

export default CalendarHeader



// WEBPACK FOOTER //
// ./src/artzu-ui/src/Calendar/CalendarHeader.js